import { Col, Row, Breadcrumb as BreadcrumbItem, theme } from 'antd';
import React from 'react'
import { Link } from 'react-router-dom';

const Breadcrumb = ({parentTitle, pageTitle}) => {

    const { token } = theme.useToken();

  return (
    <React.Fragment>
        <Row align="middle" style={{ margin: '18px 0',color: token.colorText }}>

            <Col xs={24} md={12}>
                <h1 className='ant-mb-0' style={{fontWeight:'500'}}>{pageTitle}</h1>
            </Col>
            <Col xs={24} md={12}>
                 <BreadcrumbItem
                    items={[
                    {
                        title: parentTitle
                    },
                    {
                        title: <Link href="/#" style={{color: token.colorText}}>{pageTitle}</Link>
                    }
                    ]}
                />
            </Col>
        </Row>
    </React.Fragment>
  )
}

export default Breadcrumb;
